import { useOnProductClickBase } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickBase";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { SignUpType, SignUpElement, useTrackSignupModalOpenClick } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { trackSeoSearchProductListProductLinkRefsClick } from "@faire/web-api--source/events/seo/click/searchProductListProductLinkRefs";
import { trackSignupModalOpenDiscoverProductTileClick } from "@faire/web-api--source/events/signup/click/modalOpenDiscoverProductTile";
import { trackSignupModalOpenSearchProductTileClick } from "@faire/web-api--source/events/signup/click/modalOpenSearchProductTile";
import kebabCase from "lodash/kebabCase";
export var productClickForSearchPageParametersILeanProductTileAdapter = function(productTile) {
    var _productTile_product, _productTile_product1, _productTile_product2, _productTile_product3;
    return {
        token: productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token,
        isPromoted: productTile === null || productTile === void 0 ? void 0 : (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.is_promoted,
        impressionId: productTile === null || productTile === void 0 ? void 0 : (_productTile_product2 = productTile.product) === null || _productTile_product2 === void 0 ? void 0 : _productTile_product2.impression_id,
        promotedBy: productTile === null || productTile === void 0 ? void 0 : (_productTile_product3 = productTile.product) === null || _productTile_product3 === void 0 ? void 0 : _productTile_product3.promoted_by,
        badgeList: productTile === null || productTile === void 0 ? void 0 : productTile.badge_list,
        bestImage: productTile === null || productTile === void 0 ? void 0 : productTile.best_image,
        images: productTile === null || productTile === void 0 ? void 0 : productTile.images
    };
};
export var useOnProductClickForSearchPage = function(params) {
    var onProductClickBase = useOnProductClickBase(params);
    var productSearchString = useSearchPageProductSearchString();
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var recordSignUpModalOpenCickEvent = useTrackSignupModalOpenClick();
    var isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
    return {
        onProductClick: function() {
            onProductClickBase();
            if (params.token && productSearchString) {
                trackEvent("/search-click/".concat(kebabCase(productSearchString), "/product/").concat(params.token));
                trackSeoSearchProductListProductLinkRefsClick(params.token, productSearchString);
            }
            if (!isLoggedInRetailer) {
                recordSignUpModalOpenCickEvent(SignUpType.PRODUCT, SignUpElement.PRODUCT_GRID, "logged_out_product_tile");
                if (isFromDiscoverURL) {
                    trackSignupModalOpenDiscoverProductTileClick();
                } else {
                    trackSignupModalOpenSearchProductTileClick();
                }
            }
        }
    };
};
